import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
// import { useRouter } from 'next/router';
import { NextPage } from 'next';
import { ReactElement, useEffect } from 'react';
import { IAds, TKeyAdsPage, TKeyAdsPosition } from 'src/modules/ads';
import { SHOW_COMMEMORATE } from 'src/constants';
import { useDesktop } from 'src/utils/device';
// ? TODO:  <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} page={KEY_ADS_PAGE.CONTENT} />

/* -------------------------------- KEY_TYPE -------------------------------- */

export const KEY_ADS_POSITION: TKeyAdsPosition = {
  BILLBOARD: 'billboard',
  STICKY_1: 'sticky-1',
  STICKY_2: 'sticky-2',
  STICKY_3: 'sticky-3',
  INARTICLE_1: 'inarticle-1',
  INARTICLE_2: 'inarticle-2',
  INARTICLE_3: 'inarticle-3',
  POSTARTICLE: 'postarticle',
  AD1X1: 'ad1x1',
  LIGHTBOX: 'light-box'
};

export const KEY_ADS_PAGE: TKeyAdsPage = {
  HOMEPAGE: 'homepage',
  CATEGORY: 'category',
  CONTENT: 'content',
  TAG: 'tag',
  SEARCH: 'search'
};

export const Ads = ({ slotId = '', slotSize = [], slotDefine = '', className = '' }: IAds): ReactElement | null => {
  // sizeMaps = ''
  if (isEmpty(slotId) || isEmpty(slotDefine)) return null;

  useEffect(() => {
    window.googletag?.cmd.push(() => {
      window.googletag.defineSlot(slotDefine, slotSize, slotId).addService(window.googletag.pubads()).setCollapseEmptyDiv(true, true);
      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();

      window.googletag.cmd.push(function () {
        window.googletag.display(slotId);
      });
    });
  }, []);
  return (
    <AdsWrapper className={className} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(1)' : 'unset' }}>
      <div id={slotId} />
    </AdsWrapper>
  );
};

const AdsWrapper = styled.div`
  background-color: #f5f5f5;
  &.ads-billboard {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px auto;
    min-height: 300px;
    padding: 10px 0;

    @media (max-width: 768px) {
      min-height: 100px;
    }
    iframe {
      margin: auto;
    }
  }
  &.ads-light-box {
    z-index: 51;
  }
  &.ads-ad1x1 {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  &.ads-sticky-1,
  &.ads-sticky-2,
  &.ads-sticky-3 {
    display: flex;
    justify-content: center;
    overflow: hidden;
  }
  &.ads-postarticle {
    /* //position: sticky; */
    /* //bottom: 0; */
    z-index: 50;
    display: flex;
    justify-content: center;
    overflow: hidden;
    padding: 10px 0;
    min-height: 100px;
  }

  &.ads-inarticle-1,
  &.ads-inarticle-2,
  &.ads-inarticle-3 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    height: auto;
    margin: 30px auto;
    overflow: hidden;
    padding: 10px 0;
    min-height: 100px;

    img,
    iframe {
      max-width: 100%;
      display: block;
      margin: auto;
    }
  }
`;

type Props = {
  position?: TKeyAdsPosition[keyof TKeyAdsPosition];
  data?: IAds[];
};
const DynamicAds: NextPage<Props> = ({ position = '', data = [] }) => {
  // console.log('DynamicAds', data);
  // console.log('page', page);
  // console.log('position', position);
  const _adsArray: IAds[] = !isEmpty(data) ? data : [];

  // data.filter((_data) => _data?.section === ModifyAdsSection(page, _data))
  // console.log('_adsArray', page, position, _adsArray[0]);
  // เช็คตำแหน่ง ADS
  const _adsSlot: IAds | undefined = _adsArray.find((_data: IAds) => _data?.position === position);
  if (!isEmpty(_adsSlot)) {
    const isDesktop: boolean = useDesktop();
    const slotSize: any = isDesktop ? _adsSlot?.sizeDesktop : _adsSlot?.sizeMobile;

    if (!isDesktop && isEmpty(_adsSlot?.sizeMobile)) {
      return <></>;
    }
    if (isDesktop && isEmpty(_adsSlot?.sizeDesktop)) {
      return <></>;
    }
    return (
      <>
        <Ads className={`ads-${position}`} slotDefine={_adsSlot?.slotDefine} slotId={_adsSlot?.slotId} slotSize={slotSize} position={position} />
      </>
    );
  }
  return null;
};

export default DynamicAds;
